var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"dark":"","color":"error"}},[_vm._v(_vm._s(_vm.$t('client.property-missing')))])
}
var staticRenderFns = []

export { render, staticRenderFns }